import { useState } from 'react';
import { Dealer } from 'domains/Dealer';
import { showroomRepository } from 'repositories/ShowroomRepository';
import { isOk } from 'domains/Result';

const useDealerContactDetails = (dealer: Dealer) => {
  const [isHoursOpen, setHoursOpen] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [isLocationOpen, setLocationOpen] = useState(false);
  const [dealerPhone, setDealerPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dealerOpen =
    dealer.workingHours &&
    dealer.workingHours.find((item) => item.isCurrentOpen);

  const handleShowPhoneNumber = async () => {
    if (dealerPhone) return;
    setIsSubmitting(true);
    const phoneResponse = await showroomRepository.getDealerShowroomPhone(
      dealer.id,
    );
    if (isOk(phoneResponse)) {
      setDealerPhone(phoneResponse.ok.phone);
    }
    setIsSubmitting(false);
  };

  return {
    dealerPhone,
    handleShowPhoneNumber,
    dealerOpen,
    isSubmitting,
    isLocationOpen,
    setLocationOpen,
    isHoursOpen,
    setHoursOpen,
    showEmail,
    setShowEmail,
  };
};

export { useDealerContactDetails };
